<!-- BEGIN MANTENIMIENTO NORMAL -->
<div *ngIf="form_template$ && DatosResp.Tipo=='MANTENIMIENTO'">
              <app-campo    *ngIf="mostrarCampo"
                            [form_template]="form_template$ | async"
                            [ToolbarMS]="ToolbarMS"
                            [strModoCampo]="strModoCampo"
                            [SYS02CON]="this.SYS02CON"
                            [strListener]="strEventListener"
                            [EventoCerrarMSNavID]="EventoCerrarMSNavID"
                            [SYS02JAV]="this.SYS02JAV"
                            [FormID]="this.FormID"
                            [Reportes]="this.Reportes"
                            [WORKFLOW]="this.WORKFLOW"
                            [DOC10ARC]="this.DOC10ARC"
                            [PRO10ARC]="this.PRO10ARC"
                            [WsLlaves]="this.WsLlaves"
                            [WsMasivo]="this.WsData.LLAVES"
                            [AccionesOnChange]="this.AccionesOnChange"
                            (EventoCerrarMsInterno)="EventoCerrarSimpleMsInterno($event)"
                            (EventoRecargarMsInterno)="RecargarFormulario($event)"
                            [Origen]="Origen">
  </app-campo>
</div>
<!-- END MANTENIMIENTO NORMAL -->

<!-- BEGIN MANTENIMIENTO WIZARD -->
<div class="row" *ngIf="form_template$ && DatosResp.Tipo=='MANTENIMIENTO_WIZARD'">
  <div class="col-12">
    <div class="row">
              <app-wizard   [form_template]="form_template$ | async"
                            [encabezado]="this.encabezado"
                            [SYS02CON]="this.SYS02CON"
                            [strModoCampo]="strModoCampo"
                            [Navs]="this.Navs"
                            [ToolbarMS]="this.ToolbarMS"
                            [strListener]="strEventListener"
                            [SYS02JAV]="this.SYS02JAV"
                            [FormID]="this.FormID"
                            [EventoCerrarMSNavID]="EventoCerrarMSNavID"
                            [titulo]="DatosResp.A04CDE"
                            [Reportes]="this.Reportes"
                            [WsLlaves]="this.WsLlaves"
                            [AccionesOnChange]="this.AccionesOnChange"
                            [SYS41ARC]="this.SYS41ARC"
                            [sidebar]="DatosResp.SIDEBAR_URL">
      </app-wizard>
    </div>
  </div>
</div>
<!-- END MANTENIMIENTO WIZARD -->

<!-- Begin REPORTES -->
<div class="row" *ngIf="this.strModo =='ABRIR_REPORTE_PDF' && DataReporte">
  <div class="container-fluid" style="position:sticky">
    <report-viewer [firmar]="true" [ReportData]="this.DataReporte" [tipoDocumento]="'data:application/pdf'">
    </report-viewer>
  </div>
</div>
<!-- END REPORTES -->
